import { render, staticRenderFns } from "./change-bank-card.vue?vue&type=template&id=a4bf234a&scoped=true"
import script from "./change-bank-card.vue?vue&type=script&lang=js"
export * from "./change-bank-card.vue?vue&type=script&lang=js"
import style0 from "./change-bank-card.vue?vue&type=style&index=0&id=a4bf234a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bf234a",
  null
  
)

export default component.exports